<!--
 * @Descripttion: 
 * @Author: xutao
 * @Date: 2020-11-03 15:13:01
 * @LastEditors: xutao
 * @LastEditTime: 2020-11-04 10:20:02
 * @FilePath: \yunjiactivity-h5\src\pages\vipRecall\components\hadReceiveReward.vue
-->
<template>
  <div class="had-receive-reward">
    <p class="title title1">今天已领过奖品，</p>
    <p class="title title2">请明天再来！</p>
    <div class="content">
      <p class="c-title c-title-1">已获得的奖品</p>
      <p class="c-title c-title-2">已放入{{formatReceivePhone()}}账户</p>
      <div class="reward-list">
        <rewardItem
          v-for="(itemData, index) in rewardList"
          :key="index"
          :itemData="itemData"
          class="reward-item"
        ></rewardItem>
      </div>
    </div>
  </div>
</template>
<script>
import rewardItem from './rewardItem'
import { protectPhoneNum } from '../../../common/utils/commonUtil.js'

export default {
  props: {
    rewardData: {},
    receivePhone: ''
  },
  data() {
    return {
      rewardList: []
    }
  },
  components: {
    rewardItem
  },
  methods: {
    formatReceivePhone() {
      return protectPhoneNum(this.receivePhone) || '您的'
    },
    initRewardList() {
      if (this.rewardData.length === undefined) {
        this.rewardList = [this.rewardData]
      } else {
        this.rewardList = this.rewardData
      }
    }
  },
  mounted() {
    this.initRewardList()
  }
}
</script>
<style lang="less" scoped>
.had-receive-reward {
  padding-bottom: 1rem;
}
.title {
  color: #fffab4;
  line-height: 0.8rem;
  text-align: center;
  font-weight: bold;
}
.title1 {
  font-size: 0.48rem;
  margin-top: 0.4rem;
}
.title2 {
  font-size: 0.4rem;
}
.content {
  background: #ffffff;
  border-radius: 0.4rem;
  margin: 0.8rem auto;
  width: 6.22rem;
  padding: 0.4rem 0 0.4rem;
  .c-title {
    color: #dc0000;
    line-height: 0.44rem;
    text-align: center;
    font-weight: bold;
  }
  .c-title-1 {
    font-size: 0.36rem;
  }
  .c-title-2 {
    font-size: 0.32rem;
    margin-top: 0.2rem;
  }
}
.reward-list {
  margin-top: 0.4rem;
}
</style>
